// extracted by mini-css-extract-plugin
export default {"searchBar":"ViewFeedbackForm_searchBar__XYPfq","searchText":"ViewFeedbackForm_searchText__oVN3y"};